<div class="clinical-onboarding-document-templates">
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="d-flex justify-content-between align-items-start flex-wrap mb-3 template-toolbar">
    <!-- Feedback utente: "aggiungere filtri uno per ambito e un altro per tipologia" -
         tutto lato client, l'elenco e' gia' interamente caricato in una sola chiamata. -->
    <div class="template-filters">
      <mat-form-field appearance="outline" class="template-filter-field" subscriptSizing="dynamic">
        <mat-label>{{ 'components.clinical-onboarding.document-templates.field-scope' | translate }}</mat-label>
        <mat-select [(ngModel)]="scopeFilter">
          <mat-option [value]="FILTER_ALL">{{ 'components.clinical-onboarding.document-templates.filter-all' | translate }}</mat-option>
          <mat-option [value]="ClinicianDocumentTemplateScope.GENERIC">{{ 'components.clinical-onboarding.document-templates.scope-generic' | translate }}</mat-option>
          <mat-option [value]="ClinicianDocumentTemplateScope.PER_CANDIDATE">{{ 'components.clinical-onboarding.document-templates.scope-per-candidate' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="template-filter-field" subscriptSizing="dynamic">
        <mat-label>{{ 'components.clinical-onboarding.document-templates.field-requires-upload' | translate }}</mat-label>
        <mat-select [(ngModel)]="requiresUploadFilter">
          <mat-option [value]="FILTER_ALL">{{ 'components.clinical-onboarding.document-templates.filter-all' | translate }}</mat-option>
          <mat-option value="false">{{ 'components.clinical-onboarding.document-templates.requires-upload-false' | translate }}</mat-option>
          <mat-option value="true">{{ 'components.clinical-onboarding.document-templates.requires-upload-true' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <button mat-raised-button color="primary" (click)="openCreate()">
      <mat-icon class="mr-1">add</mat-icon>
      {{ 'components.clinical-onboarding.document-templates.new-document' | translate }}
    </button>
  </div>

  @if (!loading && templates.length === 0) {
    <p class="hint-text text-center py-4">{{ 'components.clinical-onboarding.document-templates.no-documents-yet' | translate }}</p>
  } @else if (!loading && filteredTemplates.length === 0) {
    <p class="hint-text text-center py-4">{{ 'components.clinical-onboarding.document-templates.no-documents-match-filters' | translate }}</p>
  }

  @for (template of filteredTemplates; track template.id) {
    <div class="template-row">
      <div class="template-info">
        <mat-icon color="primary">description</mat-icon>
        <div class="template-info-text">
          <div class="template-type">{{ template.title }}</div>
          <div class="template-badges">
            <span class="template-badge scope-badge">
              {{ (template.scope === ClinicianDocumentTemplateScope.GENERIC
                ? 'components.clinical-onboarding.document-templates.scope-generic'
                : 'components.clinical-onboarding.document-templates.scope-per-candidate') | translate }}
            </span>
            <span class="template-badge type-badge">
              {{ (template.requires_upload
                ? 'components.clinical-onboarding.document-templates.requires-upload-true'
                : 'components.clinical-onboarding.document-templates.requires-upload-false') | translate }}
            </span>
            @if (template.visible_only_if_employer_public) {
              <span class="template-badge flag-badge" [matTooltip]="'components.clinical-onboarding.document-templates.visible-only-if-employer-public' | translate">
                <mat-icon>domain</mat-icon>
              </span>
            }
            @if (template.counts_as_invoice) {
              <span class="template-badge flag-badge" [matTooltip]="'components.clinical-onboarding.document-templates.counts-as-invoice' | translate">
                <mat-icon>receipt_long</mat-icon>
              </span>
            }
          </div>
          <div class="template-file text-muted small">
            @if (template.scope === ClinicianDocumentTemplateScope.GENERIC) {
              {{ template.file_name || ('components.clinical-onboarding.document-templates.not-uploaded' | translate) }}
            } @else {
              {{ 'components.clinical-onboarding.document-templates.per-candidate-hint' | translate }}
            }
          </div>
        </div>
      </div>
      <div class="template-action">
        @if (template.scope === ClinicianDocumentTemplateScope.GENERIC && template.file_name) {
          <button mat-icon-button color="primary" [matTooltip]="'generic.view' | translate" (click)="viewFile(template)">
            <mat-icon>visibility</mat-icon>
          </button>
        }
        <button mat-icon-button color="primary" [matTooltip]="'generic.edit' | translate" (click)="openEdit(template)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" [disabled]="removingId === template.id" [matTooltip]="'generic.remove' | translate" (click)="remove(template)">
          @if (removingId === template.id) {
            <mat-icon class="spin">autorenew</mat-icon>
          } @else {
            <mat-icon>delete_outline</mat-icon>
          }
        </button>
      </div>
    </div>
  }
</div>
